var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Glide from '@glidejs/glide';
import SocialSliderItem from './SocialSliderItem';
var SocialSlider = /** @class */ (function (_super) {
    __extends(SocialSlider, _super);
    function SocialSlider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SocialSlider.prototype.componentDidMount = function () {
        new Glide('.glide-social', { startAt: 2, gap: 40 }).mount();
    };
    SocialSlider.prototype.render = function () {
        return (React.createElement("div", { className: "c-home-social-slider" },
            React.createElement("div", { className: "glide-social" },
                React.createElement("div", { className: "glide__track", "data-glide-el": "track" },
                    React.createElement("ul", { className: "glide__slides" },
                        React.createElement("li", { className: "glide__slide" },
                            React.createElement(SocialSliderItem, { image: "/images/home/social-slideshow/1.jpg", content: "landing.social.item1.content" })),
                        React.createElement("li", { className: "glide__slide" },
                            React.createElement(SocialSliderItem, { image: "/images/home/social-slideshow/2.jpg", content: "landing.social.item2.content" })),
                        React.createElement("li", { className: "glide__slide" },
                            React.createElement(SocialSliderItem, { image: "/images/home/social-slideshow/3.jpg", content: "landing.social.item3.content" })),
                        React.createElement("li", { className: "glide__slide" },
                            React.createElement(SocialSliderItem, { image: "/images/home/social-slideshow/4.jpg", content: "landing.social.item4.content" })),
                        React.createElement("li", { className: "glide__slide" },
                            React.createElement(SocialSliderItem, { image: "/images/home/social-slideshow/5.jpg", content: "landing.social.item5.content" }))))),
            React.createElement("div", { className: "c-home-social-slider__links" },
                React.createElement("ul", null,
                    React.createElement("li", null,
                        React.createElement("a", { href: "https://www.instagram.com/fraimsy/", target: "_blank" },
                            React.createElement("i", { className: "icon-instagram h-margin-right--5" }),
                            "Instagram")),
                    React.createElement("li", null,
                        React.createElement("a", { href: "https://www.facebook.com/fraimsy", target: "_blank" },
                            React.createElement("i", { className: "icon-facebook h-margin-right--5" }),
                            "Facebook"))))));
    };
    return SocialSlider;
}(React.Component));
export default SocialSlider;
